import assign from 'lodash.assign';

import {GET_ALL_DROPS, UPDATE_DROP_TARGET, UPDATE_ACTIVE_DROP, GET_TARGET_TYPE, GET_TARGET_TYPE_HOVER, GET_SAVED_DROP_TARGETS, REMOVE_LINE} from './action';



const initialState = {
    droplEments: [],
    target: false,
    targethover: false,
};

export default function Drop(state = initialState, action) {
    switch(action.type){
        case GET_ALL_DROPS: 
            localStorage.setItem('dropelements-weland', JSON.stringify(action.items))
            return Object.assign({}, state, {
                'droplEments' : action.items,
            });
        
        case UPDATE_ACTIVE_DROP: 

        const update_active = state.droplEments.map((value, index) => {
            if(index == action.index)
            {
                return {
                    ...value,
                    ...action,
                }
            }
            return value;
        });
        console.log(update_active);
        // localStorage.setItem('dropelements-weland', JSON.stringify(...update_active))
        return Object.assign({}, state, {
            'droplEments': [
                ...update_active
            ]
        })

        case GET_TARGET_TYPE_HOVER: 
            return Object.assign({}, state, {
                targethover: action.item
            })

        case UPDATE_DROP_TARGET:
            const update = state.droplEments.map((value, index) => {
                if(index == action.index)
                {
                    let items = value.items.map((val, i) => {
                        
                        if(i === action.childIndex)
                        {
                            
                            let object = {
                                ...val,
                                ...action
                            };
                            return object;
                        }
                        return val;
                        
                    });
                    value.items = items;
                    return value;
                }
                return value;
            });
            localStorage.setItem('dropelements-weland', JSON.stringify(update))
            return Object.assign({}, state, {
                'droplEments': [
                    ...update
                ]
            })
        
        case GET_TARGET_TYPE:

        return Object.assign({}, state, {
            'target' : action
        })

        case REMOVE_LINE: 

        let update_remove = state.droplEments.map((value, index) => {
            if(index === action.index)
            {
                let items = value.items.map((val, i) => {
                    if(i === action.childIndex)
                    {
                        let object = {
                            ...val,
                            item:false
                        };

                        return object;
                    }
                    return val;
                });
                value.items = items;
                return value;
            }
            return value;

        })
        localStorage.setItem('dropelements-weland', JSON.stringify(update_remove))
            return Object.assign({}, state, {
                'droplEments': [
                    ...update_remove
                ]
            })
        

        case GET_SAVED_DROP_TARGETS:
            return Object.assign({}, state, {
                'droplEments': action.data
            })
        
        default: 
        return state;
    }
    
}


// WEBPACK FOOTER //
// ./src/Services/Drop/reducer.js